export const entities = [
    {
        name: 'CompanyStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'prospect', name: 'Prospect' },
            { id: 'client', name: 'Client' },
            { id: 'abandoned', name: 'Abandonné' },
            { id: 'target', name: 'Cible' }
        ]
    },
    {
        name: 'ContactStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'prospect', name: 'À confirmer' },
            { id: 'confirmed', name: 'Confirmé' },
            { id: 'inTouch', name: 'En contact' }
        ]
    },

    {
        name: 'Civility',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'M', name: 'Monsieur' },
            { id: 'Mme', name: 'Madame' }
        ]
    },
    {
        name: 'ProjectStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'prospective', name: 'En prospection' },
            { id: 'ongoing', name: 'En cours' },
            { id: 'closed', name: 'Terminé' },
            { id: 'abandoned', name: 'Abandonné' }
        ]
    },
    {
        name: 'SubjectStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'ongoing', name: 'Ongoing' },
            { id: 'done', name: 'Done' },
            { id: 'abandoned', name: 'Abandoned' }
        ]
    },
    {
        name: 'ActionStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'todo', name: 'À faire' },
            { id: 'ongoing', name: 'En cours' },
            { id: 'done', name: 'Terminé' },
            { id: 'abandoned', name: 'Abandonné' }
        ]
    },
    {
        name: 'Status',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'actif', name: 'Actif' },
            { id: 'inactif', name: 'Inactif' }
        ]
    },
    {
        name: 'Scope',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'regional', name: 'Régionale' },
            { id: 'national', name: 'Nationale' },
            { id: 'european', name: 'Européenne' },
            { id: 'international', name: 'Internationale' }
        ]
    },
    {
        name: 'Influence',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'low', name: 'Faible' },
            { id: 'medium', name: 'Moyen' },
            { id: 'high', name: 'Élevé' }
        ]
    },
]
